import { render, staticRenderFns } from "./main-contact.vue?vue&type=template&id=02e4ebf0&scoped=true"
import script from "./main-contact.vue?vue&type=script&lang=js"
export * from "./main-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e4ebf0",
  null
  
)

export default component.exports